import React from 'react'
import { useTranslation } from 'react-i18next'
import Navbar from '../components/navbar/navbar'

import aboutImg from '../assets/img/sb.png'
import aboutImg2 from '../assets/img/vec-2.png'

import TeamSliderTwo from '../components/team-slider-two'
import FooterTop from '../components/footer-top'
import Footer from '../components/footer'
import PageTitle from '../components/page-title'

export default function AboutUs() {
    const { t } = useTranslation();

    const data = [
        {
            icon:'fa-solid fa-unlock-keyhole text-primary',
            title: t('aboutUs.feature1Title'),
            desc: t('aboutUs.feature1Desc')
        },
        {
            icon:'fa-brands fa-handshake text-primary',
            title: t('aboutUs.feature2Title'),
            desc: t('aboutUs.feature2Desc')
        },
        {
            icon:'fa-solid fa-layer-group text-primary',
            title: t('aboutUs.feature3Title'),
            desc: t('aboutUs.feature3Desc')
        },
    ]
  return (
    <>
    <Navbar transparent={false}/>

    <PageTitle
      title={t('aboutUs.pageTitle')}
      subtitle={t('aboutUs.pageSubtitle')}
    />

    <section>
        <div className="container">
            <div className="row align-items-center">
                <div className="col-lg-6 col-md-6">
                    <img src={aboutImg} className="img-fluid" alt={t('aboutUs.ourStory')} />
                </div>
                <div className="col-lg-6 col-md-6">
                    <div className="story-wrap explore-content">
                        <h2>{t('aboutUs.ourStory')}</h2>
                        <p>{t('aboutUs.ourStoryText1')}</p>
                        <p>{t('aboutUs.ourStoryText2')}</p>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <section className="gray-bg">
        <div className="container">
            <div className="row">
                <div className="col-lg-12 col-md-12">
                    <div className="sec-heading center">
                        <h2>{t('aboutUs.meetTeam')}</h2>
                        <p>{t('aboutUs.teamSubtitle')}</p>
                    </div>
                </div>
            </div>
           <TeamSliderTwo/>
        </div>
    </section>

    <section>
        <div className="container">
            <div className="row">
                <div className="col-lg-12 col-md-12">
                    <div className="sec-heading center">
                        <h2>{t('aboutUs.missionTitle')}</h2>
                        <p>{t('aboutUs.teamSubtitle')}</p>
                    </div>
                </div>
            </div>
            <div className="row align-items-center">
                <div className="col-lg-6 col-md-6">
                    {data.map((item:any,index:number)=>{
                        return(
                            <div className="icon-mi-left" key={index}>
                                <i className={item.icon}></i>
                                <div className="icon-mi-left-content">
                                    <h4>{item.title}</h4>
                                    <p>{item.desc}</p>
                                </div>
                            </div>
                        )
                    })}
                </div>
                <div className="col-lg-6 col-md-6">
                    <img src={aboutImg2} className="img-fluid" alt={t('aboutUs.missionTitle')} />
                </div>
            </div>
        </div>
    </section>

    <FooterTop bg="theme-bg"/>
    <Footer/>
    </>
  )
}
